import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getFormUrl } from "@/mocks/formUrl";

export default function Footer() {
  const topCategories = categories.filter((_, i) => [0, 10, 9].includes(i));

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="font-heading text-lg font-semibold tracking-wide text-background-50">
              itaobuyspreadsheet
            </div>
            <p className="text-sm text-foreground-300 mt-3 leading-relaxed">
              The smartest product sourcing and shopping spreadsheet tool
              designed for global e-commerce sellers. Discover, compare, and
              track products efficiently.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Newsletter
            </h4>
            <form
              className="flex"
              data-readdy-form=""
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('.website-alt-field') as HTMLInputElement)?.value?.trim();
                if (honeypot) {
                  const msg = document.getElementById('newsletter-msg');
                  if (msg) { msg.textContent = 'Thank you for subscribing!'; msg.className = 'text-xs text-accent-400 mt-2'; }
                  return;
                }
                const email = (form.querySelector('input[name="email"]') as HTMLInputElement)?.value;
                if (!email) return;
                const body = new URLSearchParams();
                body.append('email', email);
                try {
                  const res = await fetch(getFormUrl('Newsletter Signup'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: body.toString(),
                  });
                  const msg = document.getElementById('newsletter-msg');
                  if (msg && res.ok) {
                    msg.textContent = 'Thank you for subscribing!';
                    msg.className = 'text-xs text-accent-400 mt-2';
                  }
                } catch {
                  const msg = document.getElementById('newsletter-msg');
                  if (msg) { msg.textContent = 'Something went wrong. Please try again.'; msg.className = 'text-xs text-primary-400 mt-2'; }
                }
              }}
            >
              <div className="relative flex-1">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-transparent border border-foreground-700 rounded-l-full text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-foreground-400"
                />
                <input
                  type="text"
                  name="company_alt"
                  className="website-alt-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2.5 bg-background-50 text-foreground-950 rounded-r-full hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </button>
            </form>
            <p id="newsletter-msg" className="text-xs text-foreground-400 mt-2"></p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block text-xs text-foreground-400 hover:text-foreground-200 mt-2 underline cursor-pointer"
            >
              visit main site
            </a>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Top Categories
            </h4>
            <ul className="space-y-2.5">
              {topCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Main Website
                </a>
              </li>
              <li>
                <Link
                  to="/articles/itaobuy-sheet-sourcing-guide"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Sourcing Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/50">
          <div className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-800/30 tracking-tighter select-none text-center">
            ITAOBUY
          </div>
          <p className="text-xs text-foreground-500 text-center mt-4">
            &copy; {new Date().getFullYear()} itaobuyspreadsheet. All external
            links open on kaspreadsheet.com
          </p>
        </div>
      </div>
    </footer>
  );
}